export default "__VITE_ASSET__XH6Yrv0Z__"